export default {
  form: {
    preparation_time: {
      label: 'Introduzir tempo personalizado (minutos):',
      placeholder: 'Introduzir minutos',
    },
  },
  buttons: {
    custom: 'Personalizado',
  },
  feedback: {
    preparation_time_required: 'O tempo de preparação tem de ser superior a 0 minutos',
    min_preparation_time: 'Mínimo de {{minutes}} minutos de preparação para entrega externa',
    max_preparation_time: 'Máximo de {{minutes}} minutos de tempo de preparação',
  },
};
